(() => {
  const roots = document.querySelectorAll("[data-gum-filters]");

  roots.forEach((root) => {
    const drawer = root.querySelector("[data-gum-drawer]");
    const openButtons = root.querySelectorAll("[data-gum-open-drawer]");
    const closeButtons = root.querySelectorAll("[data-gum-close-drawer]");

    if (drawer) {
      const openDrawer = () => {
        drawer.setAttribute("aria-hidden", "false");
        document.documentElement.style.overflow = "hidden";

        openButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "true");
        });
      };

      const closeDrawer = () => {
        drawer.setAttribute("aria-hidden", "true");
        document.documentElement.style.overflow = "";

        openButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "false");
        });
      };

      openButtons.forEach((button) => {
        button.addEventListener("click", openDrawer);
      });

      closeButtons.forEach((button) => {
        button.addEventListener("click", closeDrawer);
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          closeDrawer();
        }
      });
    }

    const autoSubmitInputs = root.querySelectorAll("[data-gum-auto-submit]");

    autoSubmitInputs.forEach((input) => {
      input.addEventListener("change", () => {
        const form = input.closest("form");

        if (form) {
          form.submit();
        }
      });
    });
  });
})();